import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgOpeningHoursOpenDuotone24 = function SvgOpeningHoursOpenDuotone24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.04 12c0 6.087-4.952 11.04-11.04 11.04C5.913 23.04.96 18.087.96 12 .96 5.913 5.913.96 12 .96 18.088.96 23.04 5.913 23.04 12zm.96 0c0-6.617-5.383-12-12-12S0 5.383 0 12s5.383 12 12 12 12-5.383 12-12zm-5.783.48H11.52V3.544h.96v7.976h5.737v.96z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.576 1.309A3.58 3.58 0 0 0 0 4.885 3.58 3.58 0 0 0 3.576 8.46a3.58 3.58 0 0 0 3.576-3.575 3.58 3.58 0 0 0-3.576-3.576z",
    fill: "currentColor"
  })));
};

var OpeningHoursOpenDuotone24Svg = SvgOpeningHoursOpenDuotone24;

export { OpeningHoursOpenDuotone24Svg as default };
//# sourceMappingURL=OpeningHoursOpenDuotone24.svg.js.map
